import { Store, ShoppingBag, ShoppingCart, Warehouse, Truck, Building2, Landmark, GraduationCap, HeartPulse, Factory } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const sectors = [
  { icon: Store, name: "Tiendas de conveniencia" },
  { icon: ShoppingBag, name: "Cadenas de retail" },
  { icon: ShoppingCart, name: "Supermercados" },
  { icon: Warehouse, name: "Mayoristas" },
  { icon: Truck, name: "Distribuidores" },
  { icon: Building2, name: "Empresas" },
  { icon: Landmark, name: "Gobierno" },
  { icon: GraduationCap, name: "Educación" },
  { icon: HeartPulse, name: "Salud" },
  { icon: Factory, name: "Industria" },
];

export default function Sectors() {
  return (
    <section id="sectores" className="relative py-24 md:py-36 bg-white" data-testid="sectors-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          num="07"
          chapter="Sectores que atendemos"
          id="sectores"
          title={<>Experiencia en cada <span className="text-ecamber">industria</span></>}
          sub="Nuestra operación B2B se adapta a los requerimientos de compra de cada sector."
        />
        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {sectors.map((s, i) => (
            <Reveal key={s.name} delay={(i % 5) * 0.06} y={28}>
              <div className="card-lift h-full bg-white border border-ecnavy/10 rounded-2xl p-7 flex flex-col gap-5 soft-shadow" data-testid={`sector-card-${i}`}>
                <span className="icon-tile inline-flex h-12 w-12 rounded-xl bg-ecamber/15 text-ecamber items-center justify-center">
                  <s.icon size={23} strokeWidth={1.9} />
                </span>
                <span className="font-display text-[15px] font-medium text-ecdeep leading-snug">{s.name}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
